/**
 * Sort helper for finance entity tables/cards: string (default), date, or number keys.
 * @param {object[]} rows
 * @param {{ key: string|null, direction: 'asc'|'desc' }} sortConfig
 * @param {Record<string, 'string'|'date'|'number'>} [keyTypes]
 */
export function sortRowsByConfig(rows, sortConfig, keyTypes = {}) {
  if (!sortConfig?.key) return rows;
  const type = keyTypes[sortConfig.key] || "string";
  return [...rows].sort((a, b) => {
    let aVal;
    let bVal;
    if (type === "date") {
      aVal = a[sortConfig.key] ? new Date(a[sortConfig.key]).getTime() : -1;
      bVal = b[sortConfig.key] ? new Date(b[sortConfig.key]).getTime() : -1;
    } else if (type === "number") {
      aVal = Number(a[sortConfig.key]);
      bVal = Number(b[sortConfig.key]);
      if (!Number.isFinite(aVal)) aVal = Number.NEGATIVE_INFINITY;
      if (!Number.isFinite(bVal)) bVal = Number.NEGATIVE_INFINITY;
    } else {
      aVal = a[sortConfig.key] != null ? String(a[sortConfig.key]).toLowerCase() : "";
      bVal = b[sortConfig.key] != null ? String(b[sortConfig.key]).toLowerCase() : "";
    }
    if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });
}
